import { render } from "./Folder.vue?vue&type=template&id=1be8eba5&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=1be8eba5&lang=scss&scoped=true"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be8eba5"]])

export default __exports__